<template lang="pug">
.bloco-socio-ambiental
    .bloco-socio-ambiental__titulo
        .bloco-socio-ambiental__titulo--interno
            span Total de Imóveis:
            span.negrito {{ totalImoveis }}

    .bloco-socio-ambiental__conteudo
        .bloco-socio-ambiental__conteudo--esquerdo
            span.barra-topo Bloqueados
            span.valor__negrito.mdi.mdi-close-octagon-outline {{ bloqueadosValor }}
        .bloco-socio-ambiental__conteudo--direito
            span.ajuste Alertas
            span.valor__negrito.mdi.mdi-alert-outline {{ alertasValor }}

    .bloco-socio-ambiental__alinhamento
        .bloco-socio-ambiental__alinhamento--conteudo
            span.barra-topo Desmatamentos
            span.valor__negrito {{ desmatamentos }}
        .bloco-socio-ambiental__alinhamento--conteudo
            span.barra-topo Embargos
            span.valor__negrito {{ embargos }}
        .bloco-socio-ambiental__alinhamento--conteudo
            span.barra-topo Relevância social
            span.valor__negrito {{ socialValor }}
        .bloco-socio-ambiental__alinhamento--conteudo
            span.barra-topo Áreas protegidas
            span.valor__negrito {{ areasProtegidas }}
</template>

<script>
export default {
    name: 'BlocoSocioAmbiental',
    props: {
        totalImoveis: {
            type: String,
            default: () => ''
        },
        bloqueadosValor: {
            type: String,
            default: () => ''
        },
        alertasValor: {
            type: String,
            default: () => ''
        },
        desmatamentos: {
            type: String,
            default: () => ''
        },
        embargos: {
            type: String,
            default: () => ''
        },
        socialValor: {
            type: String,
            default: () => ''
        },
        areasProtegidas: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.bloco-socio-ambiental {
    width: 100%;
    background: var(--white);
    border-radius: 5px;
    display: flex;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 12px 10px 20px;
    flex-direction: column;
    height: 405px;
    .bloco-socio-ambiental__titulo {
        display: flex;
        padding-bottom: 8px;
    }
    .bloco-socio-ambiental__titulo--interno {
        font-size: 14px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        width: 80%;
        .negrito {
            font-weight: 600;
            font-size: 20px;
            color: var(--primary);
        }
    }
    .bloco-socio-ambiental__conteudo {
        display: flex;
        margin-bottom: 15px;
        &--esquerdo {
            display: flex;
            flex-direction: column;
            min-width: 50%;
        }
        &--direito {
            display: flex;
            flex-direction: column;
        }
        .valor__negrito {
            font-weight: 700;
            display: flex;
            align-items: center;
            color: var(--primary);
        }
    }
    .bloco-socio-ambiental__alinhamento {
        display: flex;
        flex-direction: column;

        &--conteudo {
            display: flex;
            flex-direction: column;
            margin-bottom: 15px;
        }
        .valor__negrito {
            font-weight: 700;
            color: var(--primary);
        }
    }
    .barra-topo::before {
        content: '';
        display: flex;
        width: 24px;
        height: 2px;
        background: var(--secondary-two);
        clear: both;
        margin-bottom: 5px;
    }
    .ajuste {
        margin-top: 7px;
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
    .mdi-close-octagon-outline::before {
        font-size: 20px;
        color: #df675b;
        padding-right: 2px;
    }
    .mdi-alert-outline::before {
        font-size: 20px;
        color: #f88342b2;
        padding-right: 2px;
    }
}
</style>
